import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import * as Section from "@repoflow/components/section";
import SitePublicSchema from "@common/schema/site/public";
import * as HomeRoute from "./home";

// Read-only and single-page: the dashboard summarises what lives under /site, so
// there is nothing here to create, edit or address individually.
//
// The site schema alone, and nothing on this screen renders a widget for a
// declared type — Section.Provider is what supplies `base`/`basepath` to the
// route below, which is why it is here at all. datum's dashboard carries the
// same vestigial provider for the same reason.
const LocalProvider = ({ match: { params }, children: Children }) => {
  const base = `/dashboard`;
  const basepath = `/dashboard`;

  return (
    <Section.Provider
      schema={SitePublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/`} component={HomeRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <BreadcrumbItem>
            <Link to={base}>Dashboard</Link>
          </BreadcrumbItem>
          <Switch>
            <Route path={`${basepath}/`} component={HomeRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <></>;
